'use strict';
import * as $j_dev$002echeleb$002escalamigen$002epackage$0024package$0024$0024anon$00242 from "./dev.cheleb.scalamigen.package$package$$anon$2.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_package$package$Password$() {
  this.Mp = null;
  this.Mq = false;
}
export { $c_Lsamples_package$package$Password$ as $c_Lsamples_package$package$Password$ };
$p = $c_Lsamples_package$package$Password$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_package$package$Password$;
/** @constructor */
function $h_Lsamples_package$package$Password$() {
}
export { $h_Lsamples_package$package$Password$ as $h_Lsamples_package$package$Password$ };
$h_Lsamples_package$package$Password$.prototype = $p;
$p.Pb = (function() {
  if ((!this.Mq)) {
    this.Mp = new $j_dev$002echeleb$002escalamigen$002epackage$0024package$0024$0024anon$00242.$c_Ldev_cheleb_scalamigen_package$package$$anon$2(new $j_java$002elang$002e$002dObject.$c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((password$2) => password$2)));
    this.Mq = true;
  }
  return this.Mp;
});
var $d_Lsamples_package$package$Password$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_package$package$Password$, "samples.package$package$Password$", ({
  rm: 1
}));
export { $d_Lsamples_package$package$Password$ as $d_Lsamples_package$package$Password$ };
var $n_Lsamples_package$package$Password$;
function $m_Lsamples_package$package$Password$() {
  if ((!$n_Lsamples_package$package$Password$)) {
    $n_Lsamples_package$package$Password$ = new $c_Lsamples_package$package$Password$();
  }
  return $n_Lsamples_package$package$Password$;
}
export { $m_Lsamples_package$package$Password$ as $m_Lsamples_package$package$Password$ };
